<div class="container">
    <div
        class="nav-tab"
        [ngClass]="{
            active: isActiveLink('/ops/dashboard')
        }"
        (click)="onNavigateTo('/ops/dashboard')"
    >
        <mat-icon svgIcon="dashboard" />
        <span class="link-title text-xsmall">Dashboard</span>
    </div>
    <div
        class="nav-tab"
        [ngClass]="{
            active: isActiveLink('/ops/trendgraphs')
        }"
        (click)="onNavigateTo('/ops/trendgraphs')"
    >
        <mat-icon svgIcon="trendgraph" />
        <span class="link-title text-xsmall">Trend graph</span>
    </div>

    <div
        *ngIf="mimicsListArray.length > 0"
        (click)="stopPropagation($event); toggleDropdown($event)"
        class="nav-tab"
        [ngClass]="{
            active: isActiveLink('/ops/mimics') || isMimicDropdownOpen
        }"
    >
        <mat-icon svgIcon="mimics" />
        <span class="link-title text-xsmall">Mimics</span>
        <div
            class="dropdown-content"
            [ngClass]="{ group: showSubviews }"
            [style.display]="isMimicDropdownOpen ? 'block' : 'none'"
        >
            <span class="dropdown-title">{{
                "sidebar.menu.mimics.dropdown-title" | translate
            }}</span>
            <app-mimics-views-menu
                *ngFor="let v of viewsListArray"
                [view]="v"
                [selectedGroup]="selectedGroup"
                (groupSelected)="groupSelected($event)"
                (toggleDropdown)="toggleDropdown($event)"
                (onNavigateTo)="onNavigateView($event)"
            ></app-mimics-views-menu>
        </div>
        <app-mimics-groups
            *ngIf="showSubviews"
            [groupData]="selectedGroup.views"
            (stopPropagationEvent)="stopPropagation($event)"
            (toggleDropdownEvent)="toggleDropdown()"
            [styles]="{ bottom: '100%', left: '50%' }"
        >
        </app-mimics-groups>
    </div>
    <div
        class="nav-tab"
        [ngClass]="{
            active: isActiveLink('/ops/alarms')
        }"
        (click)="onNavigateTo('/ops/alarms')"
    >
        <mat-icon svgIcon="alarm-page" />
        <span class="link-title text-xsmall">Alarms</span>
    </div>
    <div
        class="nav-tab"
        [ngClass]="{
            active: isActiveLink('/ops/groups')
        }"
        (click)="onNavigateTo('/ops/groups')"
    >
        <mat-icon svgIcon="channel-list" />
        <span class="link-title text-xsmall">Channels</span>
    </div>
</div>
